/* eslint-disable lingui/no-unlocalized-strings */
import { t } from "@lingui/macro";
import { Heart, Sparkle } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const features = [
  "Plans from $9/month with a 3-day free trial",
  "Full AI writing, ATS scoring, and job matching",
  "PDF and DOCX export",
  "Professional templates and fonts",
  "Cover letters and AI assistant",
];

export const MissionSection = () => (
  <section id="mission" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mx-auto max-w-2xl text-center"
      >
        <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5 text-sm font-medium text-primary">
          <Sparkle size={16} weight="fill" />
          {t`Built by Studio Algorithm`}
        </div>
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
          {t`Built to help every job seeker`}
        </h2>
        <p className="mt-4 text-lg opacity-70">
          {t`CareerBldr is run by Studio Algorithm, a mission-driven organization. Paid plans fund the latest AI models and keep the product improving. A portion of proceeds supports accessible career education.`}
        </p>
        <p className="mt-3 text-sm opacity-60">
          {t`If you created a resume before paid plans returned, you can still download and export what you already have.`}
        </p>
      </motion.div>

      <motion.ul
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.1 }}
        className="mx-auto mt-12 grid max-w-3xl gap-3 sm:grid-cols-2"
      >
        {features.map((text) => (
          <li key={text} className="flex items-center gap-2 text-sm opacity-80">
            <Heart size={16} className="shrink-0 text-primary" weight="fill" />
            {text}
          </li>
        ))}
      </motion.ul>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2 }}
        className="mt-10 flex justify-center"
      >
        <Button asChild variant="primary" size="lg" className="gap-2">
          <Link to="/#pricing">
            {t`See plans`}
            <Sparkle size={18} weight="fill" />
          </Link>
        </Button>
      </motion.div>
    </div>
  </section>
);
